import { useState } from "react";

const LOGOS = [
  { id: "bold-wordmark", label: "Option 1 — Bold Wordmark", ext: "jpg" },
  { id: "shield-emblem", label: "Option 2 — Shield Emblem", ext: "jpg" },
  { id: "truck-mark", label: "Option 3 — Truck Mark", ext: "jpg" },
  { id: "monogram-circle", label: "Option 4 — Monogram Seal", ext: "jpg" },
];

export default function LogoPreview() {
  const [zoom, setZoom] = useState(null);

  return (
    <div className="min-h-screen py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="text-gold text-sm uppercase tracking-[0.3em] font-semibold mb-3">
            Logo Concepts
          </div>
          <h1 className="font-heading text-5xl md:text-6xl text-white uppercase">
            Pick your <span className="text-gold">Superstate</span> logo
          </h1>
          <p className="text-white/60 mt-4 max-w-xl mx-auto">
            Four AI-generated concepts. Tell me which number to apply and I'll wire it up across the site.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {LOGOS.map((l) => (
            <button
              key={l.id}
              data-testid={`logo-${l.id}`}
              onClick={() => setZoom(l)}
              className="group bg-ink-card border border-ink-line hover:border-gold/60 rounded-lg overflow-hidden transition-all hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(255,215,0,0.18)]"
            >
              <div className="aspect-square bg-ink flex items-center justify-center overflow-hidden">
                <img
                  src={`/logos/${l.id}.${l.ext}`}
                  alt={l.label}
                  className="w-full h-full object-contain group-hover:scale-[1.02] transition-transform"
                />
              </div>
              <div className="p-4 flex items-center justify-between">
                <div className="font-heading text-xl text-white uppercase tracking-wide">
                  {l.label}
                </div>
                <span className="text-gold text-xs uppercase tracking-widest font-bold">
                  Click to zoom
                </span>
              </div>
            </button>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="/"
            className="inline-block text-white/60 hover:text-gold text-sm uppercase tracking-widest"
          >
            ← Back to site
          </a>
        </div>
      </div>

      {zoom && (
        <div
          onClick={() => setZoom(null)}
          className="fixed inset-0 z-50 bg-black/90 backdrop-blur flex items-center justify-center p-6"
        >
          <img
            src={`/logos/${zoom.id}.${zoom.ext}`}
            alt={zoom.label}
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
          />
          <button
            onClick={() => setZoom(null)}
            className="absolute top-6 right-6 text-white/70 hover:text-gold text-sm uppercase tracking-wider"
          >
            Close ✕
          </button>
        </div>
      )}
    </div>
  );
}
